import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import Validator from '@/utils/Validator'
import Constants from "@/utils/Constants";
import ApiManager from "@/utils/ApiManager";
import Utility from "@/utils/Utility";

export default {
    name: 'PartnerInput',
    data() {
        return {}
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapState({
            // form
            userIdentity: state => state.partnerForm.targetId,
            values: state => state.partnerForm.values,

            // model
            serviceModel: state => state.partnerForm.serviceModel,
            partnerService: state => state.partnerForm.partnerService,
            partnerName: state => state.partnerForm.partnerName,
            partnerMail: state => state.partnerForm.partnerMail,
            partnerStatus: state => state.partnerForm.partnerStatus,

            // confirm
            confirmKey: state => state.confirm.key,
            confirmAccepted: state => state.confirm.accept
        }),
        ...mapGetters({
            isAdmin: 'auth/isAdmin',
            permittedView: 'permission/permittedView',
            isRegister: 'partnerForm/isRegister',
            isModify: 'partnerForm/isModify'
        }),

        // list
        serviceList() {
            let list = []
            this.serviceModel
                .filter(item => item.serviceStatus === 1)
                .forEach(item => list.push({
                    value: item.serviceUuid,
                    label: item.serviceName
                }))
            return list
        },
        statusList() {
            return Constants.Status
        },

        // input
        inpService: {
            get() {
                return this.values.serviceUuid
            },
            set(value) {
                this.setInputValue({
                    key: 'serviceUuid',
                    value: value
                })
            }
        },
        inpPartnerName: {
            get() {
                return this.values.partnerName
            },
            set(value) {
                this.setInputValue({
                    key: 'partnerName',
                    value: value
                })
            }
        },
        inpEmail: {
            get() {
                return this.values.email
            },
            set(value) {
                this.setInputValue({
                    key: 'email',
                    value: value
                })
            }
        },
        inpStatus: {
            get() {
                return this.values.status
            },
            set(value) {
                this.setInputValue({
                    key: 'status',
                    value: value
                })
            }
        },

        // validate
        inpServiceIsValid() {
            return Validator.validSelect(this.inpService)
        },
        inpPartnerNameIsValid() {
            return Validator.validText(this.inpPartnerName)
        },
        inpEmailIsValid() {
            return Validator.validText(this.inpEmail)
        },
        inpStatusIsValid() {
            return Validator.validSelect(this.inpStatus)
        },
        formIsValid() {
            return this.inpServiceIsValid &&
                this.inpPartnerNameIsValid &&
                this.inpEmailIsValid &&
                this.inpStatusIsValid
        },
        disableConfirmButton() {
            return !this.formIsValid
        },
        disableConfirmResetMail() {
            if (this.inpService !== this.partnerService
                || this.inpPartnerName !== this.partnerName
                || this.inpEmail !== this.partnerMail
                || this.inpStatus !== this.partnerStatus)
                return true
            else return false
        }
    },
    watch: {
        confirmAccepted: function (to) {
            console.log('confirmKey : ', this.confirmKey, to)
            // 削除
            if (this.confirmKey === 'partnerAuth' && to) {
                this.resetData()
            }
        }
    },
    methods: {
        ...mapActions({
            loadCommunityModel: 'serviceForm/loadCommunityModel',
            showConfirm: 'confirm/show',
            showError: 'error/show',
            showToast: 'toast/show'
        }),
        ...mapMutations({
            setValues: 'partnerForm/setValues',
            setInputValue: 'partnerForm/setInputValue'
        }),

        init() {
        },
        turnBack() {
            this.$router.push({
                name: 'Partner'
            })
        },

        confirmData() {
            if (!this.formIsValid) return
            // 確認画面に遷移
            this.$router.push({
                name: 'PartnerConfirm'
            })
        },

        confirmResetMail() {
            this.showConfirm({
                key: 'partnerAuth',
                title: '外部連携パートナーシークレートキー再発行',
                body: '外部連携パートナーシークレートキーを再発行します<br/>よろしいですか',
                acceptLabel: '再発行'
            })
        },

        resetData() {
            let parameters = {
                partnerUuid: this.values.partnerUuid
            }
            console.log('delete data', parameters)

            ApiManager.request(
                ['partner'],
                ['v1PartnerAuth'],
                [parameters])
                .then(res => {
                    let status = Utility.parseResponse(res)
                    if (status.result) {
                        // toast
                        this.showToast({
                            title: '外部連携パートナーシークレートキー再発行',
                            body: '外部連携パートナーシークレートキーを再発行しました。'
                        })
                    } else if (status.error) {
                        // エラーメッセージ表示
                        this.showError(res)
                    } else {
                        // アプリケーションエラー表示
                        this.showError(null)
                    }
                })
                // eslint-disable-next-line
                .catch(error => {
                    this.showError(null)
                })
        }
    }
}
